import React, { useState } from "react";
import { buildApiUrl } from "../config/api";

const UserProfile = ({ user }) => {
    const [isEditing, setIsEditing] = useState(false);
    const [currentEmail, setCurrentEmail] = useState(user.email);
    const [editData, setEditData] = useState({ email: user.email });
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setEditData((prev) => ({
            ...prev,
            [name]: value
        }));
        setError("");
        setMessage("");
    };

    const handleUpdate = async (event) => {
        event.preventDefault();
        setLoading(true);
        setError("");
        setMessage("");

        try {
            const token = localStorage.getItem("token");
            const response = await fetch(buildApiUrl("/api/auth/profile"), {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
                body: JSON.stringify(editData)
            });

            const data = await response.json();

            if (response.ok) {
                setMessage("资料已更新");
                setIsEditing(false);
                setCurrentEmail(data.user.email);
                setEditData({ email: data.user.email });
                localStorage.setItem("user", JSON.stringify(data.user));
            } else {
                setError(data.error || "更新失败，请稍后再试");
            }
        } catch (err) {
            setError("网络异常，请稍后再试。");
        } finally {
            setLoading(false);
        }
    };

    const formatDate = (dateString) => {
        return new Date(dateString).toLocaleDateString("zh-CN", {
            year: "numeric",
            month: "long",
            day: "numeric"
        });
    };

    const resetEditing = () => {
        setIsEditing(false);
        setEditData({ email: currentEmail });
        setError("");
        setMessage("");
    };

    return (
        <section className="workspace-card profile-panel">
            <div className="profile-panel__header">
                <div className="profile-panel__avatar">{user.username.charAt(0).toUpperCase()}</div>
                <div className="profile-panel__meta">
                    <h2>{user.username}</h2>
                    <span>{currentEmail}</span>
                    <span>加入时间 {formatDate(user.created_at)}</span>
                </div>
            </div>

            <div className="profile-panel__messages">
                {message && (
                    <div className="profile-panel__message profile-panel__message--success">{message}</div>
                )}
                {error && (
                    <div className="profile-panel__message profile-panel__message--error">{error}</div>
                )}
            </div>

            {isEditing ? (
                <form className="profile-panel__form" onSubmit={handleUpdate}>
                    <div className="profile-panel__field">
                        <label htmlFor="profile-email">邮箱</label>
                        <input
                            id="profile-email"
                            type="email"
                            name="email"
                            className="profile-panel__input"
                            value={editData.email}
                            onChange={handleInputChange}
                            required
                            disabled={loading}
                        />
                    </div>
                    <div className="profile-panel__actions">
                        <button
                            type="button"
                            className="btn secondary"
                            onClick={resetEditing}
                            disabled={loading}
                        >
                            取消
                        </button>
                        <button type="submit" className="btn primary" disabled={loading}>
                            {loading ? "保存中..." : "保存修改"}
                        </button>
                    </div>
                </form>
            ) : (
                <div className="profile-panel__actions">
                    <button
                        type="button"
                        className="btn primary"
                        onClick={() => {
                            setEditData({ email: currentEmail });
                            setIsEditing(true);
                        }}
                    >
                        编辑资料
                    </button>
                </div>
            )}

            <div className="profile-panel__stats">
                <div className="profile-panel__stat">
                    <span className="profile-panel__stat-value">{user.goals_count || 0}</span>
                    <span className="profile-panel__stat-label">累计目标</span>
                </div>
                <div className="profile-panel__stat">
                    <span className="profile-panel__stat-value">{user.is_active ? "活跃" : "停用"}</span>
                    <span className="profile-panel__stat-label">账号状态</span>
                </div>
            </div>

            <div className="profile-panel__info">
                <h3>账户信息</h3>
                <div className="profile-panel__info-grid">
                    <div className="profile-panel__info-item">
                        <span className="profile-panel__info-label">用户名</span>
                        <span className="profile-panel__info-value">{user.username}</span>
                    </div>
                    <div className="profile-panel__info-item">
                        <span className="profile-panel__info-label">邮箱</span>
                        <span className="profile-panel__info-value">{currentEmail}</span>
                    </div>
                    <div className="profile-panel__info-item">
                        <span className="profile-panel__info-label">账户 ID</span>
                        <span className="profile-panel__info-value">#{user.id}</span>
                    </div>
                    <div className="profile-panel__info-item">
                        <span className="profile-panel__info-label">状态</span>
                        <span className={`profile-panel__info-value ${user.is_active ? 'profile-panel__info-value--active' : 'profile-panel__info-value--inactive'}`}>
                            {user.is_active ? "Active" : "Inactive"}
                        </span>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default UserProfile;
